module.exports = __webpack_public_path__ + "img/22.3131a9eb.png";